<template>
  <div></div>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class CustomerDetailsPaymentHistory extends BaseComponent {

    id: number = null;

    mounted() {
      this.id = +this.$route.params.id || null;
    }

  }
</script>
